// Vuex
import store from '@/store.js';

import consts from "@/consts.js";
import Request from './request';

async function fetch(data) {
    return Request('get', "api/configs", data);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/configs", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    data.fieldFilter = ["id", "name"]; //仅筛选少许必要字段
    return Request('get', "api/configs/select", data, false, false, true);
}

async function fetchNetUnits() {    
    const response = await Request('get', "api/configs/select", {net_flg: 1}, true);
    if (response.data && response.data.status.isOK()) {
        store.commit("NET_UNITS", response.data.units.map((unit) => unit.name));
    }
    return response;
}

async function save(id, data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (id)
        return Request('patch', "api/configs/" + id, data);
    else
        return Request('post', "api/configs/", data);
}

export default {
    fetch,
    fetchAll,
    fetchAllForSelect,
    fetchNetUnits,
    save
};